import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/AuthService/auth.service';

@Component({
  selector: 'app-voltar',
  templateUrl: './voltar.component.html',
  styleUrls: ['./voltar.component.scss']
})
export class VoltarComponent implements OnInit {
  @Input() route: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private location: Location
  ) {}

  ngOnInit() {}

  voltar() {
    const userType = this.authService.getCurrentUserType();
    const userRoute = userType === 'PF' ? 'motorista-externo/' : 'empresa/';

    if (this.route === '') {
      this.location.back();
      return;
    }

    this.router.navigate([userRoute + this.route]);
  }
}
